/* Fierro product page: delegated events survive Theme Editor section reloads. */
(() => {
  if (window.fm13ProductInitialized) return;
  window.fm13ProductInitialized = true;
  let controller, sequence = 0;
  const observers = new Map();
  function mainFor(node) { return node.closest('[data-fm-main]'); }
  function quantity(root, requested) {
    const input = root.querySelector('input[name="quantity"]');
    if (!input) return;
    const min = Number(input.min) || 1, step = Number(input.step) || 1;
    const max = input.max ? min + Math.floor((Number(input.max) - min) / step) * step : Infinity;
    const parsed = Number(requested);
    const value = Number.isFinite(parsed) ? parsed : min;
    input.value = Math.max(min, Math.min(max, min + Math.round((value - min) / step) * step));
  }
  function refreshSticky() {
    document.querySelectorAll('#fm-barn [data-fm-main]').forEach(root => {
      const trigger = root.querySelector('[data-primary-buy]'), sticky = root.querySelector('[data-fm-sticky]');
      if (trigger && sticky) sticky.classList.toggle('visible', trigger.getBoundingClientRect().bottom <= 0);
    });
  }
  let scrollFrame = 0;
  const scheduleSticky = () => {
    if (scrollFrame) return;
    scrollFrame = requestAnimationFrame(() => { scrollFrame = 0; refreshSticky(); });
  };
  window.addEventListener('scroll', scheduleSticky, {passive:true});
  window.addEventListener('resize', scheduleSticky, {passive:true});
  function setup(context = document) {
    const roots = [...context.querySelectorAll('[data-fm-main]')];
    if (context.matches?.('[data-fm-main]')) roots.unshift(context);
    for (const [node, observer] of observers) if (!node.isConnected) { observer.disconnect(); observers.delete(node); }
    roots.forEach(root => {
      if (observers.has(root)) observers.get(root).disconnect();
      const trigger = root.querySelector('[data-primary-buy]'), sticky = root.querySelector('[data-fm-sticky]');
      if (trigger && sticky) {
        const observer = new IntersectionObserver(refreshSticky);
        observer.observe(trigger); observers.set(root, observer);
      }
      const slides = [...root.querySelectorAll('.fp-slide')];
      if (slides.length) {
        const initial = slides.find(slide => slide.dataset.mediaId === root.dataset.variantMedia) || slides.find(slide => !slide.hidden) || slides[0];
        showMedia(root, initial.dataset.mediaId);
      }
    });
    refreshSticky();
  }
  function showMedia(root, id) {
    const target = [...root.querySelectorAll('.fp-slide')].find(slide => slide.dataset.mediaId === id);
    if (!target) return;
    root.querySelectorAll('.fp-slide').forEach(slide => {
      slide.hidden = slide !== target;
      if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
      if (slide.hidden) slide.querySelectorAll('iframe').forEach(frame => {
        frame.contentWindow?.postMessage(JSON.stringify({event:'command',func:'pauseVideo',args:[]}), '*');
        frame.contentWindow?.postMessage(JSON.stringify({method:'pause'}), '*');
      });
    });
    const label = root.querySelector('[data-media-finish-label]');
    if (label) { label.textContent = target.dataset.finish || ''; label.hidden = !label.textContent; }
    root.querySelectorAll('[data-show-media]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.showMedia === id)));
  }
  async function chooseOption(link) {
    const root = mainFor(link), run = ++sequence;
    if (!root) return;
    controller?.abort(); controller = new AbortController();
    const messages = JSON.parse(root.querySelector('[data-fm-messages]')?.textContent || '{}');
    const oldQuantity = root.querySelector('input[name="quantity"]')?.value;
    const status = root.querySelector('[data-variant-status]');
    const states = root.fm13ButtonStates || [...root.querySelectorAll('button[name="add"]')].map(button => [button, button.disabled]);
    root.fm13ButtonStates = states;
    states.forEach(([button]) => button.disabled = true);
    root.setAttribute('aria-busy', 'true');
    if (status) { status.textContent = messages.loading || 'Atualizando…'; status.hidden = false; }
    const linkUrl = new URL(link.href, location.href);
    const displayUrl = new URL(location.href);
    displayUrl.searchParams.delete('variant');
    displayUrl.searchParams.set('option_values', linkUrl.searchParams.get('option_values'));
    const requestUrl = new URL(displayUrl);
    requestUrl.searchParams.set('section_id', root.dataset.sectionId);
    try {
      const response = await fetch(requestUrl, { signal:controller.signal, credentials:'same-origin', headers:{Accept:'text/html'} });
      if (!response.ok) throw new Error('Variant rendering failed');
      const documentNext = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = documentNext.querySelector('[data-fm-main]');
      if (!next || !next.querySelector('.fp-product-form')) throw new Error('Missing product form');
      if (run !== sequence || !root.isConnected) return;
      quantity(next, oldQuantity);
      root.querySelectorAll('video').forEach(video => video.pause());
      root.replaceWith(next);
      setup(next);
      next.querySelector(`[data-option-id="${CSS.escape(link.dataset.optionId)}"]`)?.focus({preventScroll:true});
      history.replaceState({}, '', displayUrl);
    } catch (error) {
      if (run !== sequence || error.name === 'AbortError') return;
      root.removeAttribute('aria-busy');
      states.forEach(([button, disabled]) => button.disabled = disabled);
      delete root.fm13ButtonStates;
      if (status) { status.textContent = messages.error || 'Não foi possível atualizar. Tente novamente.'; status.hidden = false; }
    }
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('#fm-barn [data-show-media],#fm-barn [data-quantity],#fm-barn [data-option-id]');
    if (!target) return;
    const root = mainFor(target);
    if (!root) return;
    if (target.dataset.showMedia) { showMedia(root, target.dataset.showMedia); return; }
    if (target.dataset.quantity) {
      const input = root.querySelector('input[name="quantity"]');
      quantity(root, (Number(input?.value) || 1) + (target.dataset.quantity === 'plus' ? 1 : -1) * (Number(input?.step) || 1));
      return;
    }
    if (target.dataset.optionId && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault(); chooseOption(target);
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('#fm-barn input[name="quantity"]')) quantity(mainFor(event.target), event.target.value);
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('#fm-barn .fp-product-form')) return;
    const root = mainFor(event.target);
    if (root.getAttribute('aria-busy') === 'true' || !event.target.querySelector('input[name="id"]:not(:disabled)')?.value) { event.preventDefault(); return; }
    quantity(root, event.target.querySelector('input[name="quantity"]')?.value);
  });
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', () => setup());
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('.fp-slide');
    if (slide) showMedia(mainFor(slide), slide.dataset.mediaId);
    const details = event.target.closest('details'); if (details) details.open = true;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
})();
/* Delivery quotes use the merchant's public app proxy; never mutate /cart. */
(() => {
  if (window.fm14DeliveryInitialized) return;
  window.fm14DeliveryInitialized = true;
  const runs = new WeakMap();
  function reset(form) {
    runs.get(form)?.abort(); runs.delete(form);
    form.querySelector('button').disabled = false;
    form.removeAttribute('aria-busy');
    const result=form.querySelector('[data-cep-result]');result.replaceChildren();result.hidden=true;
  }
  function invalidate(root) { root?.querySelectorAll('[data-fm-delivery]').forEach(reset); }
  document.addEventListener('input', e => {
    if (!e.target.matches('#fm-barn [name="postal_code"]')) return;
    const digits=e.target.value.replace(/\D/g,'').slice(0,8);
    e.target.value=digits.length>5?digits.slice(0,5)+'-'+digits.slice(5):digits;
    reset(e.target.form);
  });
  document.addEventListener('click', e => {
    if(e.target.closest('#fm-barn [data-quantity],#fm-barn [data-option-id]')) invalidate(e.target.closest('[data-fm-main]'));
  });
  document.addEventListener('change', e => {
    if(e.target.matches('#fm-barn input[name="quantity"]')) invalidate(e.target.closest('[data-fm-main]'));
  });
  document.addEventListener('shopify:section:unload',e=>invalidate(e.target));
  document.addEventListener('submit', async e => {
    const form=e.target;
    if(!form.matches('#fm-barn [data-fm-delivery]'))return;
    e.preventDefault();reset(form);
    const root=form.closest('[data-fm-main]'),input=form.querySelector('input'),result=form.querySelector('[data-cep-result]');
    const messages=JSON.parse(form.querySelector('[data-cep-messages]').textContent);
    const say=text=>{result.textContent=text;result.hidden=false;};
    const zip=input.value.replace(/\D/g,'');
    if(zip.length!==8){input.setAttribute('aria-invalid','true');say(messages.invalid);input.focus();return;}
    input.removeAttribute('aria-invalid');
    const variant=root.querySelector('.fp-product-form input[name="id"]:not(:disabled)')?.value;
    if(!variant||root.getAttribute('aria-busy')==='true'){say(messages.variant);return;}
    if(!form.dataset.endpoint){say(messages.unavailable);return;}
    const controller=new AbortController();runs.set(form,controller);
    const timeout=setTimeout(()=>controller.abort(),12000);
    form.querySelector('button').disabled=true;form.setAttribute('aria-busy','true');say(messages.loading);
    try {
      const url=new URL(form.dataset.endpoint,location.href);
      if(!['https:','http:'].includes(url.protocol)||url.origin!==location.origin)throw Error('Use a same-origin app proxy');
      url.searchParams.set('zip',zip);url.searchParams.set('country','BR');url.searchParams.set('variant_id',variant);
      url.searchParams.set('quantity',root.querySelector('[name="quantity"]')?.value||'1');
      const response=await fetch(url,{credentials:'same-origin',signal:controller.signal,headers:{Accept:'application/json'}});
      if(!response.ok)throw Error('Quote unavailable');
      const data=await response.json();
      // Require an explicit transport estimate. A postcode address lookup is not a delivery quote.
      const valid=Array.isArray(data.rates)?data.rates.filter(rate=>
        Number.isInteger(rate.min_business_days)&&Number.isInteger(rate.max_business_days)&&
        rate.min_business_days>=0&&rate.max_business_days>=rate.min_business_days&&
        rate.max_business_days<=365&&rate.transit_only===true):[];
      if(!valid.length)throw Error('No confirmed transport estimate');
      if(runs.get(form)!==controller||!form.isConnected)return;
      result.replaceChildren();result.hidden=false;
      valid.slice(0,10).forEach(rate=>{
        const row=document.createElement('p');
        const range=rate.min_business_days===rate.max_business_days?String(rate.min_business_days):`${rate.min_business_days} a ${rate.max_business_days}`;
        row.textContent=`${rate.name?String(rate.name)+' · ':''}${messages.transport}: ${range} ${messages.days}.`;
        result.append(row);
      });
      const note=document.createElement('p');note.textContent=messages.note;result.append(note);
    } catch(error) {
      if(runs.get(form)===controller&&form.isConnected)say(messages.unavailable);
    } finally {
      clearTimeout(timeout);
      if(runs.get(form)===controller){form.querySelector('button').disabled=false;form.removeAttribute('aria-busy');runs.delete(form);}
    }
  });
})();
